import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress
} from '@material-ui/core';
import { useSwaggerClient } from '../../hooks/useSwaggerClient';

function EmaillogModal({ id, showModal, MODAL_TYPE }) {
    const [rerender, setRerender] = useState(0);
    const [data, loading] = useSwaggerClient('emaillogs', 'getEmaillogById', { id }, [rerender]);

    // iframe hack
    useEffect(() => {
        if (loading || !data?.html) {
            return undefined;
        }
        // fill the iframe
        const timeout = setTimeout(() => {
            const x = document.getElementById('emailFrame');
            if (!x) {
                return;
            }
            const y = x.contentWindow || x.contentDocument;
            y.document.write(data?.html);
        }, 100);

        return () => clearTimeout(timeout);
    }, [data, loading]);

    const localDev = window.location.href.indexOf('127.0.0.1') !== -1;

    return (
        <Dialog
            aria-labelledby="emaillog-modal"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
            maxWidth="md"
        >
            <DialogTitle>Email</DialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        Date: {data?.created_at}
                        <br />
                        To: {data?.to}
                        <br />
                        Subject: {data?.subject}
                        <br />
                        Result: {data?.result}
                        <br />
                        Status: {data?.status}
                        <br />
                        <iframe
                            id="emailFrame"
                            width="740"
                            title="email"
                            style={{ border: '1px solid black', height: '50vh' }}
                        ></iframe>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                {localDev && (
                    <Button
                        variant="contained"
                        onClick={() => {
                            setRerender(x => x + 1);
                        }}
                    >
                        Rerender
                    </Button>
                )}
                <Button
                    variant="contained"
                    onClick={() => {
                        showModal(MODAL_TYPE.NONE);
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EmaillogModal;
